import { TaskListItem } from '@myapp/contract'
import { getTaskColors } from './timelineConstants'
import { isMidnightScheduledDate } from '../model/useTimelineTasks'

interface Props {
  task: TaskListItem
  onClick?: () => void
}

function formatTime(iso: string): string {
  const d = new Date(iso)
  return `${String(d.getHours()).padStart(2, '0')}:${String(d.getMinutes()).padStart(2, '0')}`
}

export const WeekTaskPill = ({ task, onClick }: Props) => {
  const isAllDay = !task.plannedStart || isMidnightScheduledDate(task.plannedStart)

  let label: string
  if (isAllDay) {
    label = `Ganztag: ${task.title}`
  } else {
    const workStart = new Date(task.actualStart ?? task.plannedStart!)
    const workDuration = task.actualWorkDuration ?? task.plannedWorkDuration
    const workEnd = new Date(workStart.getTime() + workDuration * 60_000)
    label = `${formatTime(workStart.toISOString())}–${formatTime(workEnd.toISOString())} ${task.title}`
  }

  return (
    <div
      className="flex items-center gap-0.5 rounded px-1 py-0.5 text-[11px] leading-tight text-white truncate cursor-pointer"
      style={{ backgroundColor: getTaskColors(task.status).workColor }}
      onMouseDown={(e) => {
        if (onClick) {
          e.stopPropagation()
          onClick()
        }
      }}
      title={label}
    >
      <span
        className="w-1 self-stretch rounded-sm shrink-0"
        style={{ backgroundColor: getTaskColors(task.status).travelColor }}
      />
      <span className="truncate">{label}</span>
    </div>
  )
}
